import { ROUTE_TESTING_PLAN } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './testing-plan.page';

export const routeTestingPlan: RouteObject = {
  path: ROUTE_TESTING_PLAN,
  Component: Page,
  loader: setTitleFromLoader('Testing Plan'),
};
